export default __webpack_public_path__ + "static/logo-black-b1e98feba12f1cd424668eef8d447ce6.png";